import { Component, Input } from '@angular/core';
import { ItemProfitibilityReportStoreService } from '../item-profitibility-report-store.service';
import { MatDialog } from '@angular/material/dialog';
import { ItemDialogComponent } from '../../../shared/dialogs/item-dialog/item-dialog.component';
import { ConfigService } from '../../../shared/services/config.service';
import { MomentModule } from 'ngx-moment';
import { HlCurrencyPipe } from '../../../shared/pipes/hl-currency.pipe';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-item-profitability-table',
    templateUrl: './item-profitability-table.component.html',
    standalone: true,
    imports: [NgIf, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, RouterLink, MatIcon, MatTooltip, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, AsyncPipe, HlCurrencyPipe, MomentModule]
})
export class ItemProfitabilityTableComponent {
  help = {
    purchase:
      'The purchase price of the item, and the date purchased if known.',
    parts: 'The sale price of any parts used in workshop jobs for the item.',
    labour: 'The number of hours logged for workshop jobs for the item.',
    labourCost:
      'The cost of labour for workshop jobs for the item, uses the "Labour cost per hour" value above to determine this',
    profit:
      'The profit made on the item, calculated as the revenue minus the cost of parts, labour and purchase price.',
    revenue:
      'The revenue made on the item, calculated as the sum of all hires for the item.'
  };
  results$ = this.store.results$;
  loading$ = this.store.loadingResults$;

  displayedColumns = [
    'item',
    'product',
    'revenue',
    'cost',
    'maintenance',
    'labour_hours',
    'labour_cost',
    'profit'
  ];

  @Input() currency = 'GBP';

  dateFormat = ConfigService.dates.dateFormat;

  constructor(
    private store: ItemProfitibilityReportStoreService,
    private dialog: MatDialog
  ) {}

  openItemDialog(productId: number, itemId: number) {
    this.dialog.open(ItemDialogComponent, {
      data: { item: { id: itemId, product_id: productId } }
    });
  }
}
